import { Box, Stack, Typography} from '@mui/material';
import {GalleryCard} from "../widgets/GalleryCard.tsx";
import {useAppSelector} from "../app/store/hooks.ts";
import {useGenerationPolling} from "../entities/hooks/usePoolingGenerations.ts";

export const Gallery = () => {
    const generations = useAppSelector((state) => state.user.generations);
    useGenerationPolling()


    return (
        <Stack sx={{width: '100%'}} display={'flex'} flexDirection={'column'} spacing={2} padding={'0 0 40px 0'}>
            <Box width={'100%'} margin={'0 0 0 8px !important'}>
                <Typography variant={'h3'} sx={{ fontWeight: '600', textAlign: 'left', opacity: 0.8 }}>Gallery</Typography>
            </Box>

            {generations.length === 0 ? (
                <Typography variant={'body1'} sx={{ textAlign: 'center', opacity: 0.6, py: 4 }}>
                    No generations yet
                </Typography>
            ) : (
                <Box display="grid" gridTemplateColumns="repeat(4, 1fr)" gap={.2} sx={{width: '100%'}}>
                    {generations.map((generation) => (
                        <GalleryCard key={generation.id} generation={generation} />
                    ))}
                </Box>
            )}
        </Stack>
    )
};
